@if (!noRoleUpdate) {
<div class="lob-model-view">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="uitk_new_header">
        <div class="uitk-l-grid__col--12 stk-container-tabl-header">
          <div class="stk-header-action ">
            <div class="table-header-icons row">
              @if (dataSourceDetails && dataSourceDetails.data.length) {
              <div class="table-search col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-6">
                <mat-form-field class="data-filter" appearance="outline" style="padding: 0px;">
                  <input
                    [(ngModel)]="searchField"
                    matInput
                    type="text"
                    class="capability-search"
                    placeholder="Search Segment/LOB/SubLOB/User"
                    (keyup)="searchDataSet($event)"
                  />
                  <img src="../../../../assets/images/searchicon.png" class="lob-view-search-img" />
                </mat-form-field>
              </div>
              } @if (selectedInitiative && tabledata?.length > 0) {
              <div
                class="table-header-icons table-header-icons-buttons col-md-8 col-sm-6 col-lg-8 col-xl-8 col-xs-6 pull-right"
              >
                @if (isUserAdmin) {
                <button
                  (click)="AddNewEntry()"
                  class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                >
                  Add/Remove User
                </button>
                } @if (dataSourceDetails && dataSourceDetails.data.length) {
                <button
                  (click)="expandAllFunc()"
                  class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                >
                  {{ allRowsExpanded ? 'Collapse All' : 'Expand All' }}
                </button>
                }
                <div (click)="exportToExcel()" class="export-link d-inline m-2 pull-right">
                  <span
                    title="Click to Download"
                    class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
                  ></span>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="uitk-c-card__content" style="margin-top: 0px !important;">
        <div class="stk-table-container ei-role-table">
          @if (showLoader) {
          <div class="stk-table-loader">
            <app-loader> </app-loader>
          </div>
          } @if (!showLoader && selectedInitiative && tabledata.length > 0) {
          <app-maintenance-table-v4
            [TABLE_CONFIG]="TABLE_CONFIG"
            [COLUMNS]="TABLE_COLUMNS"
            [expanded_columns]="expanded_columns"
            [SORT_CONFIG]="sortConfig"
            [dataSource]="dataSourceDetails"
            [childDataSource]="dataSourceDetails"
            [SCHEMA]="DATA_SCHEMA"
            (saveEvent)="saveEvent($event)"
            [expandAll]="expandAll"
            [selectedInitiative]="selectedInitiative"
            [pageSize]="TABLE_CONFIG.pageSize"
            (collapseAll)="collapseAllFunc($event)"
            [pageIndex]="TABLE_CONFIG.pageIndex"
            (notifyToParentInitiative)="notifyToParentInitiative()"
          >
          </app-maintenance-table-v4>
          }
        </div>
      </div>
    </div>
  </div>
</div>
} @if (!showLoader &&selectedInitiative && tabledata.length > 0) {
<div>
  <app-modal id="addRemoveCAModel" class="modal-delete" #modalAddRole [inViewport]="true" (closeModal)="closemodal()">
    <ng-container class="app-modal-header">Add/Remove User</ng-container>
    <ng-container class="app-modal-body">
      <app-add-remove-popup
        (addRemoveSuccessEvent)="saveEvent($event)"
        [selectedInitiative]="selectedInitiative"
        [dataSource]="tabledata"
        [popupName]="'AddRemoveRole'"
        [clearFormFields]="clearFormFields"
      >
      </app-add-remove-popup>
    </ng-container>
  </app-modal>
</div>
} @if (noRoleUpdate) {
<div class="noRoleUpdateDiv">
  <span>
    There are no roles available to view/update. Please go to&nbsp;
    <span class="link-block">
      <a class="link-click" href="javascript:void(0)" (click)="navigateToLOBManagement()">
        LOB Management
      </a>
    </span>
    &nbsp;for LOB details</span
  >
</div>
}
